import { render, staticRenderFns } from "./referrer.vue?vue&type=template&id=15f9706b&scoped=true"
import script from "./referrer.vue?vue&type=script&lang=js"
export * from "./referrer.vue?vue&type=script&lang=js"
import style0 from "./referrer.vue?vue&type=style&index=0&id=15f9706b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f9706b",
  null
  
)

export default component.exports